module.exports = __webpack_public_path__ + "static/media/202409xibao.99950c37.jpg";